import { Suspense, useEffect, useRef, useState } from "react"
import { useNavigate, useRoutes } from "react-router-dom"
import HomePage from "./pages/homePage"
import EditWishPage from "./pages/editWishPage"
import LoginPage from "./pages/loginPage"
import AdminPage from "./pages/adminPage"
import { useReduxDispatch } from "./store/useReduxDispatch"
import { startupThunk } from "./thunks/startupThunks"
import { ThemeContainer } from "./components/layout/ThemeContainer"
import { logOut } from "./services/authService"
import { useSelector } from "react-redux"
import { settingsSelectors } from "./slices/settingsSlice"

function App(): JSX.Element {
  const dispatch = useReduxDispatch()
  const navigate = useNavigate()

  const quitRef = useRef(0)

  const settings = useSelector(settingsSelectors.settings)

  useEffect(() => {
    document.title = settings?.isDev ? "Dev Ønskeliste" : "Ønskeliste"
  }, [settings])

  useEffect(() => {
    dispatch(startupThunk(navigate))

    const keyPressHandler = (event: KeyboardEvent) => {
      if (event.key === "q") {
        quitRef.current = quitRef.current + 1
        if (quitRef.current >= 5) {
          logOut()
        }
      } else if (quitRef.current > 0) {
        quitRef.current = 0
      }
    }
    addEventListener("keypress", keyPressHandler)

    return () => {
      removeEventListener("keypress", keyPressHandler)
    }
  }, [])
  return (
    <Suspense fallback={<p>Loading...</p>}>
      <ThemeContainer>
        {!!settings &&
          useRoutes([
            { path: "/", element: <HomePage /> },
            { path: "login", element: <LoginPage /> },
            { path: "editWish/:id", element: <EditWishPage /> },
            { path: "editWish", element: <EditWishPage /> },
            { path: "admin", element: <AdminPage /> },
          ])}
      </ThemeContainer>
    </Suspense>
  )
}

export default App
